/** @format */

const API = {
  getListSysEvents: '/monitor/?Action=ListSysEvents&Version=2021-01-01', // 获取系统事件
  /* eslint-disable max-len */
  getAccountAllProjectList: '/monitor/?Action=GetAccountAllProjectList&Version=2015-11-01', // 获取所有项目
  getDescribeSystemEventHistogram:
    '/monitor/?Action=DescribeSystemEventHistogram&Version=2021-01-01', // 获取系统事件图表
  /* eslint-disable max-len */
  getDescribeSystemEventCount: '/monitor/?Action=DescribeSystemEventCount&Version=2021-01-01', // 获取系统事件列表
  getDescribeSystemEventAttribute:
    '/monitor/?Action=DescribeSystemEventAttribute&Version=2021-01-01', //获取事件详情
  createEventPolicy: '/monitor/?Action=CreateEventPolicy&Version=2021-01-01', // 创建事件策略
  getPolictResource: '/monitor/?Action=DescribeEventPolicyResources&Version=2021-01-01', // 获取事件策略关联资源
  modifyEventPolicy: '/monitor/?Action=ModifyEventPolicy&Version=2021-01-01' // 修改事件策略
}
export default API
